import { IconComponent } from 'design-system/types'

export const ArrowDown: IconComponent = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    {...props}>
    <path
      d="M15.717 9.79c-.2-.2-.45-.29-.71-.29H9.003c-.26 0-.51.09-.71.29-.39.39-.39 1.03 0 1.42l3.002 3c.39.39 1.02.39 1.41 0l3.002-3c.39-.39.39-1.03 0-1.42h.01Z"
      fill="currentColor"
    />
  </svg>
)
